module.exports = __webpack_public_path__ + "static/media/laxmiraj-problem.f0645375.png";